import { render, staticRenderFns } from "./AnnouncementDisplay.vue?vue&type=template&id=6599b4ba"
import script from "./AnnouncementDisplay.vue?vue&type=script&lang=js"
export * from "./AnnouncementDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports